import React from 'react';
import HeaderMain from '../HeaderMain/HeaderMain';




const Header = () => {
    return (
        <div>
            
            <HeaderMain></HeaderMain>
        </div>
    );
};

export default Header;